import type { Incident, Unschedule } from "../models/Incidents.ts";
import { parseTimeToMinutes } from "./payrollBranchMeta.ts";

function splitScheduleStart(startTime?: string | null): string {
  if (!startTime) return "";
  const parts = String(startTime).split(" - ").map((part) => part.trim());
  return parts[0] || "";
}

function partnerSortName(incident: Incident): string {
  const person = incident?.schedule?.partner?.person;
  return `${person?.firstName || ""} ${person?.lastName || ""} ${person?.secondLastName || ""}`
    .trim()
    .toLowerCase();
}

function unschedulePartnerSortName(record: Unschedule): string {
  const person = record?.partner?.person;
  return `${person?.firstName || ""} ${person?.lastName || ""} ${person?.secondLastName || ""}`
    .trim()
    .toLowerCase();
}

/** Minutos desde medianoche para ordenar por entrada (real o planeada). */
export function getIncidentEntrySortMinutes(incident: Incident): number {
  const checkIn =
    incident?.checkIn ??
    incident?.schedule?.assistanceCheck ??
    incident?.schedule?.checkIn;

  if (checkIn?.checkTime) {
    return parseTimeToMinutes(checkIn.checkTime);
  }

  const checks = incident?.schedule?.checks || [];
  if (checks.length > 0) {
    let earliest = Number.POSITIVE_INFINITY;
    for (const check of checks) {
      if (check?.checkTime) {
        earliest = Math.min(earliest, parseTimeToMinutes(check.checkTime));
      }
    }
    if (Number.isFinite(earliest)) {
      return earliest;
    }
  }

  const plannedStart = splitScheduleStart(incident?.schedule?.startTime);
  if (plannedStart) {
    return parseTimeToMinutes(plannedStart);
  }

  return 24 * 60;
}

export function getUnscheduleEntrySortMinutes(record: Unschedule): number {
  if (record?.checkIn?.checkTime) {
    return parseTimeToMinutes(record.checkIn.checkTime);
  }
  return 24 * 60;
}

export function sortIncidentsByEntryTime(incidents: Incident[]): Incident[] {
  return [...incidents].sort((a, b) => {
    const diff = getIncidentEntrySortMinutes(a) - getIncidentEntrySortMinutes(b);
    if (diff !== 0) return diff;
    return partnerSortName(a).localeCompare(partnerSortName(b), "es");
  });
}

export function sortUnscheduleByEntryTime(records: Unschedule[]): Unschedule[] {
  return [...records].sort((a, b) => {
    const diff =
      getUnscheduleEntrySortMinutes(a) - getUnscheduleEntrySortMinutes(b);
    if (diff !== 0) return diff;
    return unschedulePartnerSortName(a).localeCompare(
      unschedulePartnerSortName(b),
      "es"
    );
  });
}
